import Config from "../../config";
import DT from "date-and-time";
export function getBlockedUntilTime(dateString) {
    if (dateString) {
        const time = dateString.split("T")[1];
        return time;
    }
    return null;
}
export function subtractDay(datestring) {
    const { patterns } = Config.date;
    const date = DT.addDays(DT.parse(datestring, patterns.de), -1);
    return DT.format(date, patterns.de);
}
export function getScrollOffset() {
    return (window.scrollY ||
        window.pageYOffset ||
        document.body.scrollTop +
            ((document.documentElement && document.documentElement.scrollTop) || 0));
}
export function buildWtmDirectLink(webtextName, app) {
    const { urls } = Config;
    return `${urls.WEBTEXT}#!/form/${webtextName}/${app}`;
}
export function logError(error, print) {
    if (print) {
        console.error(error, { cause: error });
    }
    try {
    }
    catch {
    }
}
